function linkTo(app, file) {
  return generateFilePath(app, "", file);
}
const linkToRemoteBase = (service) => "/remote.php/" + service;
function generateRemoteUrl(service, options) {
  ensureBaseUrlInNonDomEnvironment(options);
  const baseURL = options?.baseURL ?? getBaseUrl();
  return baseURL + linkToRemoteBase(service);
}
function generateOcsUrl(url, params, options) {
  const allOptions = { ocsVersion: 2, ...options || {} };
  ensureBaseUrlInNonDomEnvironment(allOptions);
  const version = allOptions.ocsVersion === 1 ? 1 : 2;
  const baseURL = options?.baseURL ?? getBaseUrl();
  return baseURL + "/ocs/v" + version + ".php" + _generateUrlPath(url, params, options);
}
function _generateUrlPath(url, params, options) {
  const allOptions = { escape: true, ...options || {} };
  const _build = function(text, vars) {
    vars = vars || {};
    return text.replace(/{([^{}]*)}/g, function(a, b) {
      const r = vars[b];
      if (allOptions.escape) {
        return typeof r === "string" || typeof r === "number" ? encodeURIComponent(r.toString()) : encodeURIComponent(a);
      } else {
        return typeof r === "string" || typeof r === "number" ? r.toString() : a;
      }
    });
  };
  if (url.charAt(0) !== "/") {
    url = "/" + url;
  }
  return _build(url, params || {});
}
function generateUrl(url, params, options) {
  const allOptions = { noRewrite: false, ...options || {} };
  ensureBaseUrlInNonDomEnvironment(allOptions);
  const baseOrRootURL = options?.baseURL ?? getRootUrl();
  if (!allOptions.noRewrite && typeof window !== "undefined" && window.OC?.config?.modRewriteWorking === true) {
    return baseOrRootURL + _generateUrlPath(url, params, options);
  }
  return baseOrRootURL + "/index.php" + _generateUrlPath(url, params, options);
}
function imagePath(app, file) {
  if (!file.includes(".")) {
    return generateFilePath(app, "img", `${file}.svg`);
  }
  return generateFilePath(app, "img", file);
}
function generateFilePath(app, type, file) {
  ensureDomEnvironment();
  const isCore = window.OC?.coreApps?.includes(app) ?? false;
  const isPHP = file.slice(-3) === "php";
  let link = getRootUrl();
  if (isPHP && !isCore) {
    link += `/index.php/apps/${app}`;
    if (type) {
      link += `/${encodeURI(type)}`;
    }
    if (file !== "index.php") {
      link += `/${file}`;
    }
  } else if (!isPHP && !isCore) {
    link = getAppRootUrl(app);
    if (type) {
      link += `/${type}/`;
    }
    if (link.at(-1) !== "/") {
      link += "/";
    }
    link += file;
  } else {
    if ((app === "settings" || app === "core" || app === "search") && type === "ajax") {
      link += "/index.php";
    }
    if (app) {
      link += `/${app}`;
    }
    if (type) {
      link += `/${type}`;
    }
    link += `/${file}`;
  }
  return link;
}
function getBaseUrl() {
  ensureDomEnvironment();
  return window.location.protocol + "//" + window.location.host + getRootUrl();
}
function getRootUrl() {
  ensureDomEnvironment();
  let webroot = window._oc_webroot;
  if (typeof webroot === "undefined") {
    webroot = location.pathname;
    const pos = webroot.indexOf("/index.php/");
    if (pos !== -1) {
      webroot = webroot.slice(0, pos);
    } else {
      const index = webroot.indexOf("/", 1);
      webroot = webroot.slice(0, index > 0 ? index : void 0);
    }
  }
  return webroot;
}
function getAppRootUrl(app) {
  ensureDomEnvironment();
  const webroots = window._oc_appswebroots ?? {};
  return webroots[app] ?? "";
}
function ensureDomEnvironment() {
  if (typeof window === "undefined") {
    throw new Error("This function is only available in a DOM environment");
  }
}
function ensureBaseUrlInNonDomEnvironment(options) {
  if (typeof window === "undefined" && !options?.baseURL) {
    throw new Error("This function requires baseURL option to be provided in non-DOM environments");
  }
}
/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: GPL-3.0-or-later
 */
function generateAvatarUrl(user, options) {
  const size = (options?.size || 64) <= 64 ? 64 : 512;
  const guestUrl = options?.isGuestUser ? "/guest" : "";
  const themeUrl = options?.isDarkTheme ? "/dark" : "";
  const url = generateUrl(`/avatar${guestUrl}/{user}/{size}${themeUrl}`, {
    user,
    size
  });
  const query = new URLSearchParams();
  if (options?.guestFallback) {
    query.set("guestFallback", "true");
  }
  if (options?.version !== void 0) {
    query.set("v", String(options.version));
  }
  const queryString = query.toString();
  return queryString ? `${url}?${queryString}` : url;
}
export {
  generateAvatarUrl,
  generateFilePath,
  generateOcsUrl,
  generateRemoteUrl,
  generateUrl,
  getAppRootUrl,
  getBaseUrl,
  getRootUrl,
  imagePath,
  linkTo
};
//# sourceMappingURL=index.mjs.map
